import generateReportFromView from '@opsbase/lib-data-view/helpers/generateReportFromView';
import generateViewFromReport from '@opsbase/lib-data-view/helpers/generateViewFromReport';
import DataType from '@opsbase/lib-datatype/DataType';
import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useReportCreate from '@opsbase/react-gql-hooks/report/useReportCreate';
import useSelfUpdate from '@opsbase/react-gql-hooks/self/useSelfUpdate';
import useView from '@opsbase/web-ctrl-view/useView';
import useViewRegistryActions from '@opsbase/web-ctrl-view/useViewRegistryActions';
import CreateDialog from '@opsbase/web-dialogs/CreateDialog';
import useNav from '@opsbase/web-nav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import TextField from '@opsbase/web-textfield/TextField';
import React, { useCallback, useState } from 'react';
export function ReportCreateDialog() {
    const { viewId } = useParams();
    const [title, setTitle] = useState('');
    const { preferences } = useSelf();
    const updateSelf = useSelfUpdate();
    const { raise } = useNotificationActions();
    const view = useView(viewId);
    const { replaceTo, goBack } = useNav();
    const createReport = useReportCreate();
    const { putView } = useViewRegistryActions();
    const handleCreate = useCallback(() => raise(createReport({ patch: { ...generateReportFromView(view, title), title } }), i18n.t('savedview-save-successful')), [createReport, raise, title, view]);
    const handleAfterCreate = useCallback(report => {
        const newView = generateViewFromReport(report);
        preferences.setFavourite(newView.id, true);
        updateSelf({ preferences }).catch(doNothing);
        putView(newView);
        if (report.type === DataType.OP) {
            replaceTo(Pages.OPS_LOG, { viewId: newView.id });
        }
        else if (report.type === DataType.ISSUE) {
            replaceTo(Pages.ISSUES_LOG, { viewId: newView.id });
        }
        else if (report.type === DataType.OPDEFINITION) {
            replaceTo(Pages.OP_DEFINITIONS, { viewId: newView.id });
        }
        else {
            goBack();
        }
    }, [goBack, preferences, putView, replaceTo, updateSelf]);
    return (React.createElement(CreateDialog, { padded: true, valid: title.length > 1, onCreate: handleCreate, afterCreate: handleAfterCreate, title: i18n.t('save-report-as') },
        React.createElement(TextField, { white: true, label: i18n.t('title'), autoFocus: true, value: title, onChange: setTitle, fullWidth: true })));
}
export default ReportCreateDialog;
